import {DialogManager} from '@modifi/plugin-dialogs'

import CompanyConfirmationDialog, {
  DIALOG_NAME as COMPANY_CONFIRMATION_DIALOG,
} from './company-confirmation-dialog'

DialogManager.addDialog(COMPANY_CONFIRMATION_DIALOG, CompanyConfirmationDialog)

export {DIALOG_NAME as COMPANY_CONFIRMATION_DIALOG} from './company-confirmation-dialog'
